export const changePlanMutation = () => `
    mutation changePlan($planChange: ChangePlanInput!){
        changePlan(planChange: $planChange) {
            __typename
            ... on PlanChangeInfo {
                dateInEffect
            }
            ... on PlanChangeError {
                error
            }
        }
    }
`;


export const createOrderMutation = () => `
    mutation createOrder($order: CreateOrderInput!, $origin: OperationOrigin) {
      createOrder(order: $order, origin: $origin) {
        __typename
        ... on OrderCreation{
            id
        },
        ... on OrderCreationError {
            error,
            outOfStockIds
        }
      }
    }
`;